export default __webpack_public_path__ + "static/68851-aa2ddaceab2f55d332feb14cbe4b25ac.jpg";